import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { Link } from "react-router-dom";

export default function Reset() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleReset = async () => {
    setError("");
    if (!email) {
      setError("Introduce tu correo electrónico.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setSent(true);
    } catch (err) {
      console.error(err.code);
      if (err.code === "auth/user-not-found") {
        setError("No existe ninguna cuenta con ese correo.");
      } else {
        setError("Ha ocurrido un error. Inténtalo más tarde.");
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-6">
      <div className="bg-white p-8 rounded-xl shadow-md w-full max-w-md text-center">
        <img src="/noltrade_gpt.png" alt="Noltrade" className="h-12 mx-auto mb-6" />

        <h1 className="text-xl font-semibold text-gray-800 mb-4">Restablecer contraseña</h1>
        {sent ? (
          <p className="text-green-600">
            Te hemos enviado un correo con el enlace para restablecer tu contraseña.
          </p>
        ) : (
          <>
            <input
              type="email"
              placeholder="Tu correo electrónico"
              className="border w-full p-3 rounded mb-4"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />

            <button
              onClick={handleReset}
              className="w-full bg-[#f0b632] text-black p-3 rounded hover:brightness-110 transition mb-4"
            >
              Enviar enlace
            </button>

            {error && (
              <div className="bg-red-100 text-red-700 p-3 rounded text-sm">{error}</div>
            )}
          </>
        )}

        <p className="text-sm text-gray-500 mt-6">
          <Link to="/login" className="hover:underline text-[#f0b632]">
            ← Volver al login
          </Link>
        </p>
      </div>
    </div>
  );
}
